import React, { useCallback, useContext, useState } from 'react'
import { ParentContext } from '../ParentContext';
import { AppUserContext } from '../AppUserContext';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import { convertSnapshot } from '../contextHelpers';
import { _globalTicketingName } from 'projectSpecific/ticketing/cnr/reducers/TicketingReducer';
import _ from 'lodash';
import { TriMenu } from 'global/components/menus/TriMenu';
import { writeBatch } from 'firebase/firestore';
import { fsfn_updateTicketAssignments } from 'global/functions/fbTicketing';

const _useTicketingSubCollection = false
const _allowTicketingUpdates = false

export const useTicketing = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns, fn_cls } = parentContext ?? {}
  const { app_state, currentSettings_state, paps_state } = states ?? {}
  const { mainDb } = app_state ?? {}
  const { pathViews } = paps_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { database_fns } = fns ?? {}
  let { willCall: _willCallKey } = pathViews ?? {}

  const appUserContext = useContext(AppUserContext);
  const { appUser_state } = appUserContext ?? {}
  const { appUser } = appUser_state ?? {}

  const { appTicketing } = aps_global ?? {}
  const { ticketingCollectionName } = appTicketing ?? {}

  const [tickets, setTickets] = useState({})
  const [allTicketsAlt, setAllTicketsAlt] = useState({})
  const [allTickets, setAllTickets] = useState({})
  const [updating, setUpdating] = useState()

  const getTickets = useCallback(async () => {
    if (ticketingCollectionName) {
      database_fns.get_data_any({ pathViews, collectionName: ticketingCollectionName, callback: setTickets })
      getTicketing(database_fns, pathViews, setAllTickets, setAllTicketsAlt)
    }
  }, []);

  const updateTicket = useCallback(async ({ assignedTickets, ticketKey, subTicketKey, registrationId, credit }) => {
    if (ticketingCollectionName) {
      const cb = () => { setUpdating() }
      setUpdating(true)
      const _assignedTickets = _.cloneDeep(assignedTickets)
      const subTickets = _assignedTickets?.[ticketKey]?.userTickets?.[registrationId]?.subTickets
      const subTicketIndex = _.findIndex(subTickets, { subTicketKey })
      subTickets[subTicketIndex].entered = credit ? false : true
      const _ref = createRefPath_event(pathViews, [_globalTicketingName, ticketKey])
      const dataToUpdate = {
        [`userTickets.${registrationId}.subTickets`]: subTickets
      }
      database_fns.update_doc(_ref, dataToUpdate, cb)
    }
  }, []);

  const getWillCallTickets = useCallback(async () => {
    if (ticketingCollectionName) {

      const { appUserAccess, phoneNumber: phoneNumber_appUser, email: email_appUser } = appUser ?? {}
      let { willCall: _willCallKey } = pathViews ?? {}

      // if the willCallKey is not in the pathView, assign it by the auth email or phoneNumber
      if (!_willCallKey) {
        switch (willCallType) {
          case willCallTypes.email:
            if (email_appUser) { _willCallKey = email_appUser }
            break;
          case willCallTypes.phone:
            if (phoneNumber_appUser) { _willCallKey = phoneNumber_appUser }
            break;
          default:
            break;
        }
      }

      database_fns.get_data_any({ pathViews, collectionName: ticketingCollectionName, callback: setTickets })
      getTicketing(database_fns, pathViews, setAllTickets, setAllTicketsAlt)

      // if (_willCallKey && tickets && groupedWillCalls) {
      //   ticketing_handlers.handleGetWillCallByKey(_willCallKey, pathViews.willCall)
      // }

    }
  }, []);

  const updateAppUserTicket = useCallback(async ({ ticketKey, registrationId, allotment, currentAllotment, subTickets }) => {
    if (ticketingCollectionName) {
      const cb = () => { setUpdating() }
      setUpdating(true)
      const _allotment = currentAllotment - allotment
      const subTicks = createUserSubTickets(database_fns, _allotment, ticketKey, subTickets, registrationId)
      const _ref = createRefPath_event(pathViews, [_globalTicketingName, ticketKey])
      const dataToUpdate = {
        [`userTickets.${registrationId}.allotment`]: currentAllotment,
        [`userTickets.${registrationId}.subTickets`]: subTicks
      }
      database_fns.update_doc(_ref, dataToUpdate, cb)
    }
  }, []);

  const assignTickets = useCallback(async ({ ticketing_state, action }) => {

    const { appTicketing, willCallTicketPath } = ticketing_state
    const { ticketKey, subTicket, unforward } = action
    const { sendSmsOrEmailOnAssignment } = appTicketing ?? {}

    const smsEmailData = sendSmsOrEmailOnAssignment && !unassign ? getSmsEmailData({
      appTicketing,
      willCallTicketPath,
      action,
    }) : {}

    const cb_updated = () => {

    }

    const cb = (assignedTickets) => {
      updateTicketing(
        mainDb,
        fn_cls,
        database_fns,
        ticketKey,
        pathViews,
        assignedTickets,
        smsEmailData,
        tickets,
        appTicketing,
        cb_updated
      )
    }

    getDataToUpdateForAssignment({
      ticketing_state,
      action,
      callback: cb
    })
  }, []);


  const forwardTickets = useCallback(async ({ ticketing_state, action }) => {

    const { appTicketing, willCallTicketPath, assignedTickets } = ticketing_state
    const { ticketKey, smsEmailData, subTicket, unforward } = action

    const cb_updated = () => {

    }

    const cb_subTicket = (assignedTickets) => {
      updateTicketing(
        mainDb,
        fn_cls,
        database_fns,
        ticketKey,
        pathViews,
        assignedTickets,
        smsEmailData,
        tickets,
        appTicketing,
        cb_updated
      )
    }
    const { sendSmsOrEmailOnAssignment } = appTicketing ?? {}
    const _smsEmaiData = sendSmsOrEmailOnAssignment && !unforward ? getSmsEmailData({ appTicketing, willCallTicketPath, action }) : {}
    ammendWillCallSubTicket(action, assignedTickets, subTicket, _smsEmaiData, cb_subTicket)
  }, []);

  return { getTickets, forwardTickets, assignTickets, getWillCallTickets, updateTicket, updateAppUserTicket, updating, tickets, allTickets, allTicketsAlt }
}

const getTicketing = (database_fns, pathViews, callback, callbackAlt) => {

  const _refPath = createRefPath_event(pathViews, [_globalTicketingName])

  const cb = (data) => {
    callback(data)
  }

  //   const { refPath, wheres, callback, opts, fs } = props
  // const { listen, altDb } = opts ?? {}

  database_fns.get_data({ refPath: _refPath, callback: cb, opts: { listen: true } }).then(data => {
    callback(data)
    if (_useTicketingSubCollection) {
      if (data) {
        Object.keys(data).forEach(key => {
          const _ticketPaths = createRefPath_event(pathViews, [_globalTicketingName, key, 'userTickets'])
          database_fns.get_data({ refPath: _ticketPaths }).then(sss => {
            const dataC = convertSnapshot(sss, false, { ignoreId: true })
            callbackAlt(dataC, key)
          })
        })
      }
    } else {
      callback(data)
    }
  })
}

const ammendWillCallTicketsByWillCallKey = (state, willCallKey1, willCallKey2, callback) => {

  const { groupedWillCalls, tickets, selectedLookupTicketKey } = state
  const _willCallKeyPathView = willCallKey2 ? willCallKey2 : null
  const _key = _willCallKeyPathView ? _willCallKeyPathView : willCallKey1

  const willCallItem = _key ? groupedWillCalls[_key] : null

  if (willCallItem) {
    const _tickets = getWillCallBy(tickets, willCallItem, _key, _willCallKeyPathView, selectedLookupTicketKey)
    if (callback) {
      callback(_tickets, null, _key)
    } else {
      return _tickets
    }
  } else {
    if (callback) {
      callback(null)
    } else {
      return {}
    }
  }
}

const initUserTicket = (assignedTickets, ticketKey, itemKey) => {
  if (!assignedTickets[ticketKey]) { assignedTickets[ticketKey] = {} }
  if (!assignedTickets[ticketKey].userTickets) { assignedTickets[ticketKey].userTickets = {} }
  if (!assignedTickets[ticketKey].userTickets[itemKey]) { assignedTickets[ticketKey].userTickets[itemKey] = {} }
}

const ticketInfo = (assignedTickets) => {
  if (assignedTickets) {
    Object.keys(assignedTickets).forEach(ticketKey => {
      const assignedTicket = assignedTickets[ticketKey]
      let _allotment = 0
      let entered = 0
      let assignedTo = 0
      let _max = 0
      if (assignedTicket) {
        const { userTickets, status } = assignedTicket ?? {}
        const { max } = status ?? {}
        _max = max
        if (userTickets) {
          Object.keys(userTickets).forEach(userKey => {
            const userTicket = userTickets[userKey]
            if (userTicket) {
              const { allotment, subTickets } = userTicket
              _allotment += parseInt(allotment)
              if (subTickets && _.isArray(subTickets)) {
                subTickets.forEach(subTicket => {
                  const { entered: u, assignedTo: at } = subTicket ?? {}
                  if (u) { entered++ }
                  if (at) { assignedTo++ }
                  subTicket.registrationId = userKey
                })
              }
            }
          })
        }
      }
      assignedTicket.status = {
        allotment: _allotment,
        entered,
        assignedTo,
        max: _max
      }
    })
  }
}

const createUserSubTickets = (database_fns, count, ticketKey, subTicks, registrationId) => {
  if (count && count > 0) {
    let _index = subTicks.length + 1
    const userTickets = []
    for (var i = 1; i <= count; i++) {
      userTickets.push({
        entered: false,
        subTicketKey: database_fns.get_docKey('subTicket'),
        subTicketIndex: _index,
        ticketKey,
        registrationId
      })
      _index++
    }
    return [...subTicks, ...userTickets]
  }
  return []
}

const getSmsEmailData = ({ appTicketing, willCallTicketPath, action }) => {

  const { sendSmsOrEmailOnAssignment, smsMessageText, emailSubjectText, emailBodyText, emailSender } = appTicketing ?? {}
  const { unassign, phoneNumber, email } = action ?? {}

  let _smsData;
  let _emailData;

  if (sendSmsOrEmailOnAssignment && !unassign) {
    if (phoneNumber) {
      _smsData = { to: phoneNumber, text: inviteText(willCallTicketPath, null, smsMessageText, false) }
    }
    if (email) {
      _emailData = {
        email: {
          recipient: email,
          sender: emailSender ? emailSender : 'support@meetingevolution.net',
          subject: emailSubjectText,
          body: inviteText(willCallTicketPath, null, emailBodyText, true),
        }
      }
    }
  }

  return {
    smsData: _smsData,
    emailData: _emailData
  }
}

const inviteText = (willCallTicketPath, willCallNumber, smsMessageText, isEmail) => {
  let text = smsMessageText ? smsMessageText + '\r\n' : 'You have been invited to an event. Here is your link to your will call ticket(s):\r\n'
  const wctp = willCallTicketPath.replace(/\s/g, '%20')
  text += wctp
  if (isEmail) {
    text += 'Email'
  } else {
    text += 'Phone'
  }
  if (willCallNumber) { text += '/' + willCallNumber }

  return text
}

const getDataToUpdateForAssignment = ({ ticketing_state, action, callback }) => {

  const { assignedTickets, currentTicketUserKey, subTicketsSelected } = ticketing_state ?? {}
  const { unassign, phoneNumber, email, ticketKey, contact, subTicketSelected, userTicket } = action ?? {}
  const { ticketKey: ticketKey_sub, registrationId, subTicketKey } = userTicket ?? {}
  const contactName = contact && contact.name ? contact.name : null

  if (userTicket) {
    const dataToUpdate = updateTicketingForAssignment(ticketing_state, ticketKey_sub, registrationId, subTicketKey, email ? email : phoneNumber)
    callback(ticketKey, dataToUpdate)
  } else {
    const _assignedTickets = { ...assignedTickets }
    const assignedTicket = _assignedTickets ? _assignedTickets[ticketKey] : null
    if (assignedTicket) {
      const { userTickets } = assignedTicket ?? {}
      if (userTickets && (subTicketsSelected || subTicketSelected)) {
        const userSubTicket = userTickets[currentTicketUserKey]
        if (userSubTicket) {
          const { subTickets, allotment } = userSubTicket
          if (subTickets && _.isArray(subTickets)) {
            subTickets.forEach(subTicket => {
              delete subTicket._itemKey
              if (subTicketsSelected.includes(subTicket.subTicketKey)) {
                if (unassign) {
                  delete subTicket.assignedTo
                  delete subTicket.assignedToName
                  delete subTicket.forwardedTo
                } else {
                  subTicket.assignedTo = email ? email : phoneNumber
                  if (contactName) { subTicket.assignedToName = contactName }
                }
              }
            })
          }
          const dataToUpdate = {
            [ticketKey]: {
              userTickets: {
                [currentTicketUserKey]:
                {
                  allotment,
                  subTickets: subTickets
                }
              }
            }
          }
          callback(dataToUpdate)
        }
      }
    }
  }
}


const updateTicketingForAssignment = (assignedTickets, ticketKey, registrationId, subTicketKey, assignedTo) => {
  if (assignedTickets && assignedTickets[ticketKey] && assignedTickets[ticketKey].userTickets && assignedTickets[ticketKey].userTickets[registrationId] && assignedTickets[ticketKey].userTickets[registrationId][subTicketKey]) {
    const ust = assignedTickets[ticketKey].userTickets[registrationId][subTicketKey]
    ust.assignedTo = assignedTo
    const dataToUpdate = {
      [ticketKey]: {
        userTickets: {
          [registrationId]: {
            [subTicketKey]: ust
          }
        }
      }
    }
    return dataToUpdate
  }
}

const ammendWillCallSubTicket = (action, assignedTickets, subTicket, smsEmailData, callback) => {
  const { phoneNumber, email, unforward } = action ?? {}
  const { ticketKey, registrationId, subTicketKey } = subTicket
  const subTickets = getAssignedTicketSubTickets(assignedTickets, ticketKey, registrationId)
  if (subTickets) {
    const subTicket = _.find(subTickets, { subTicketKey: subTicketKey })
    if (subTicket) {
      if (unforward) {
        delete subTicket.forwardedTo
      } else {
        subTicket.forwardedTo = email ? email : phoneNumber
      }
      const dataToUpdate = {
        [ticketKey]: {
          userTickets: {
            [registrationId]: {
              subTickets: subTickets
            }
          }
        }
      }
      callback(ticketKey, dataToUpdate, smsEmailData)
    }
  }
}

const updateTicketing = async (
  mainDb,
  fn_cls,
  database_fns,
  ticketKey,
  pathViews,
  assignedTickets,
  smsEmailData,
  tickets,
  appTicketing,
  callback
) => {

  const batch = writeBatch(mainDb);

  const { useMeTicketingAllotmentFunction } = appTicketing
  const { smsData, emailData } = smsEmailData ?? {}

  const _refPath = createRefPath_event(pathViews, [_globalTicketingName, ticketKey])

  if (assignedTickets && ticketKey && assignedTickets[ticketKey]) {

    const ticket = tickets && tickets[ticketKey] ? tickets[ticketKey] : {}
    const { name: ticketName } = ticket ?? {}

    console.log('useMeTicketingAllotmentFunction', useMeTicketingAllotmentFunction)

    if (useMeTicketingAllotmentFunction) {
      fsfn_updateTicketAssignments(pathViews, assignedTickets, callback).then(response_data => {
        const { success, error } = response_data ?? {}
        console.log('success', success, error)
        callback()
      }).catch(error => {
        console.error(error)
      })
    } else {
      const assignedTicket = assignedTickets[ticketKey]
      if (!assignedTicket.ticketName && ticketName) { assignedTicket.ticketName = ticketName }

      if (_useTicketingSubCollection) {
        try {
          try {
            const { userTickets } = assignedTicket ?? {}
            delete assignedTicket.userTickets

            console.log('_refPath', _refPath, assignedTicket)
            // refPath, data, merge, dispatch, batch, altDb
            database_fns.set_doc(_refPath, assignedTicket, true, null, batch)

            if (userTickets) {
              Object.keys(userTickets).forEach(userTicketKey => {
                const userTicket = userTickets[userTicketKey]
                const { subTickets } = userTicket ?? {}
                if (subTickets) {
                  const updatePath = _refPath + '/userTickets/' + userTicketKey
                  console.log('_refPath', updatePath, assignedTicket)
                  // refPath, data, merge, dispatch, batch, altDb
                  database_fns.set_doc(updatePath, assignedTicket, true, null, batch)
                  // database_fns.set_doc(updatePath, assignedTicket, true, null, batch).then(() => {
                  //   console.log('SUCCESS')
                  // }).catch(error => {
                  //   console.error(error)
                  // })
                }
              })
            }

            if (_allowTicketingUpdates) {
              await batch.commit()
              callback({ success: true })
            }

            // database_fns.set_doc(_refPath, assignedTicket, true).then(() => {
            //   if (userTickets) {
            //     Object.keys(userTickets).forEach(userTicketKey => {
            //       const userTicket = userTickets[userTicketKey]
            //       const { subTickets } = userTicket ?? {}
            //       if (subTickets) {
            //         const updatePath = _refPath + '/userTickets/' + userTicketKey
            //         database_fns.set_doc(updatePath, assignedTicket, true).then(() => {
            //           console.log('SUCCESS')
            //         }).catch(error => {
            //           console.error(error)
            //         })
            //       }
            //     })
            //   }
            // }).catch(error => {
            //   console.error(error)
            //   callback({ success: true, error })
            // })
          } catch (error) {
            console.error(error)
            callback({ success: true, error })
          }
        } catch (error) {
          console.error(error)
          callback({ success: true, error })
        }
      } else {
        try {

          console.log('_refPath', _refPath, assignedTicket)

          database_fns.set_doc(_refPath, assignedTicket, true, null, batch)

          if (_allowTicketingUpdates) {
            await batch.commit()
            if (smsData) { fn_cls.sendSms(smsData) }
            if (emailData) { fn_cls.sendEmail(emailData) }
            callback({ success: true })
          }

          // database_fns.set_doc(_refPath, assignedTicket, true).then(() => {
          //   if (smsData) { fn_cls.sendSms(smsData) }
          //   if (emailData) { fn_cls.sendEmail(emailData) }
          //   callback({ success: true })
          // }).catch(error => {
          //   console.error(error)
          // })
        } catch (error) {
          console.error(error)
          callback({ success: true, error })
        }
      }
    }
  }
}